const TriggerBalanceUpdate = ({ balance, usdt }) => {
    localStorage.setItem("balance", balance);
    localStorage.setItem("usdt_balance", usdt);
    window.dispatchEvent(new Event("balanceUpdated"));
};

export { TriggerBalanceUpdate };